// src/ui/components/RiskGauge.tsx
import { colors } from "../design-system/colors";
import { fontFamily, typeScale } from "../design-system/typography";
import { space, radius } from "../design-system/spacing";
import type { RiskLevel } from "../../workers/kinematics.worker";

// 2.3節アクセシビリティ: 色だけに依存せず、記号(○/△/×)を併用して
// 色覚特性に関わらずリスクレベルを判別できるようにする。
const RISK_META: Record<RiskLevel, { symbol: string; label: string; color: string }> = {
  safe: { symbol: "○", label: "安全域", color: colors.safe },
  caution: { symbol: "△", label: "注意", color: colors.caution },
  danger: { symbol: "×", label: "危険域", color: colors.danger },
};

export default function RiskGauge({
  riskLevel,
  compressionN,
  shearN,
}: {
  riskLevel: RiskLevel;
  compressionN: number;
  shearN: number;
}) {
  const meta = RISK_META[riskLevel];
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: space.md,
        padding: space.md,
        borderRadius: radius.md,
        background: colors.surface,
        border: `1px solid ${colors.surfaceBorder}`,
      }}
    >
      <div
        aria-hidden="true"
        style={{
          width: 48,
          height: 48,
          borderRadius: radius.full,
          background: `${meta.color}22`,
          color: meta.color,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.5rem",
          fontWeight: 700,
          flexShrink: 0,
        }}
      >
        {meta.symbol}
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontFamily: fontFamily.ui, fontWeight: 600, color: colors.textPrimary }}>
          {meta.label}
        </div>
        <div
          style={{
            fontFamily: fontFamily.numeric,
            fontSize: typeScale.caption.size,
            color: colors.textSecondary,
            display: "flex",
            gap: space.md,
            marginTop: 2,
          }}
        >
          <span>L4/L5圧縮 {compressionN.toFixed(0)}N</span>
          <span>せん断 {shearN.toFixed(0)}N</span>
        </div>
      </div>
    </div>
  );
}
